var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInterestingLinksIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 12,
    viewBox: "0 0 23 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.25 0.00195312H12.65V2.40195H17.25C19.1475 2.40195 20.7 4.02195 20.7 6.00195C20.7 7.98195 19.1475 9.60195 17.25 9.60195H12.65V12.002H17.25C20.424 12.002 23 9.31395 23 6.00195C23 2.68995 20.424 0.00195312 17.25 0.00195312ZM10.35 9.60195H5.75C3.8525 9.60195 2.3 7.98195 2.3 6.00195C2.3 4.02195 3.8525 2.40195 5.75 2.40195H10.35V0.00195312H5.75C2.576 0.00195312 0 2.68995 0 6.00195C0 9.31395 2.576 12.002 5.75 12.002H10.35V9.60195ZM6.9 4.80195H16.1V7.20195H6.9V4.80195Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterestingLinksIcon);
export default __webpack_public_path__ + "static/media/interestingLinks_icon.80d0eca5ac87aa304bc47787c7baa2e0.svg";
export { ForwardRef as ReactComponent };